import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Button, Card, Checkbox, Chip, CircularProgress, TextField } from '@mui/material';
import React, { useContext, useEffect, useState, useMemo } from 'react'
import AuthContext from '../../../context/AuthContext';
import { CheckBox, Close, ExpandMore, Cancel } from '@mui/icons-material';

export default function CouponDetails({ couponDetails, setCouponDetails, orderedCategoriesData, setOrderedCategoriesData, errors, setError }) {

  const authCtx = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [categoriesData, setCategoriesData] = useState([]);
  const [currentKeyword, setKeyword] = useState('');
  const [accorrdionDetails, setAccordionDetails] = useState([]);
  const [expandId, setExpanId] = useState(null);
  const [companyIncluded, setCompanyIncluded] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const flatOptions = useMemo(() => {
    return (orderedCategoriesData || []).map(o => ({
      id: o.id,
      title: (o.title || '').toString(),
      parentId: o.parentId,
      parentTitle: o.parentTitle
    }));
  }, [orderedCategoriesData]);

  const normalize = s => (s || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').replace(/\s+/g, ' ').trim().toLowerCase();

  const selectedOptionObjects = useMemo(() => {
    const safe = flatOptions || [];
    return (couponDetails?.categories || []).map(id => safe.find(option => option.id === id)).filter(Boolean);
  }, [flatOptions, couponDetails?.categories]);

  useEffect(() => {
    getAllCategories();
    // Initialize checkbox state from couponDetails if it exists
    if (couponDetails.companyKeywords === true) {
      setCompanyIncluded(true);
    }
  }, [])

  const getAllCategories = () => {
    try {
      setLoading(true);
      fetch(`${process.env.REACT_APP_API_URI}/v3/admin/categories`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: "Bearer " + authCtx.token }
      }).then(response => {
        return response.json();
      }).then(data => {
        setLoading(false);
        if (data.status === 'success') {
          const categoriesWithSubcategories = data?.data || [];
          
          // build categoriesData (parents + children) as you already do
          const transformedData = categoriesWithSubcategories.map(category => ({
            parent: {
              id: category.id,
              title: category.title,
              parent: category.parent
            },
            children: (category.subcategories || []).sort((a, b) => a.title.localeCompare(b.title))
          })).sort((a, b) => a.parent.title.localeCompare(b.parent.title));
          setCategoriesData(transformedData);

          // ALSO build a flattened stable list of subcategories (with parent info)
          const flattened = categoriesWithSubcategories.flatMap(category =>
            (category.subcategories || []).map(child => ({
              id: child.id,
              title: child.title,
              parentId: category.id,
              parentTitle: category.title
            }))
          );
          
          // Remove duplicates by ID, keeping the first occurrence
          const uniqueFlattened = flattened.filter((item, index, self) => 
            index === self.findIndex(t => t.id === item.id)
          ).sort((a, b) => a.title.localeCompare(b.title));
          console.log(uniqueFlattened, "uniqueFlattened");
          setOrderedCategoriesData(uniqueFlattened);
        }
      })
    } catch (err) {
      console.error(err)
    }
  }

  const selectCouponCategories = (_couponCategories) => {
    setError('categories', false);
    setCouponDetails({ ...couponDetails, categories: _couponCategories })
  }
  const setCouponClaimUrl = (_url) => {
    setCouponDetails({ ...couponDetails, couponClaimUrl: _url });
    if (_url || couponDetails.phoneNumber || couponDetails.emailAddress) {
      setError('website', false);
      setError('contactMethod', false);
    }
  }
  const setPhoneNumber = (_phone) => {
    setCouponDetails({ ...couponDetails, phoneNumber: _phone });
    if (_phone || couponDetails.emailAddress || couponDetails.couponClaimUrl) {
      setError('phone', false);
      setError('mail', false);
      setError('contactMethod', false);
    }
  }
  const setEmail = (_email) => {
    setCouponDetails({ ...couponDetails, emailAddress: _email });
    if (_email || couponDetails.phoneNumber || couponDetails.couponClaimUrl) {
      setError('phone', false);
      setError('mail', false);
      setError('contactMethod', false);
    }
  }
  const selectKeywords = (_keywords) => {
    setCouponDetails({ ...couponDetails, keywords: _keywords })
  }
  const setCouponCode = (_couponCode) => {
    setCouponDetails({ ...couponDetails, couponCode: _couponCode })
  }

  const handleKeyboardSubmit = (e) => {
    e.preventDefault();
    if (currentKeyword.trim() && !couponDetails.keywords.includes(currentKeyword.trim())) {
      setCouponDetails({ ...couponDetails, keywords: [...couponDetails.keywords, currentKeyword.trim()] });
      setKeyword('');
    }
  }

  const handlePanelChange = (panel) => (event, newExpanded) => {
    setExpanId(newExpanded ? panel : null);
    if(!newExpanded) setAccordionDetails([]);
  };

  return (
    <div className='create-coupon-section-v2'>
      <div className='vertical-container'>
        <div className='horizontal-row-card-container vertical'>

          {loading ? <CircularProgress /> : <>
            <Card className='card-container' sx={{ width: '100%' }}>
            <Autocomplete
              limitTags={3}
              fullWidth
              multiple
              options={flatOptions}
              getOptionLabel={(option) => option?.title || ''}
              inputValue={searchValue}
              onInputChange={(event, newInputValue) => setSearchValue(newInputValue ?? '')}
              filterOptions={(options, { inputValue }) => {
                const term = normalize(inputValue || '');
                if (!term) return options;
                const filtered = options.filter(opt => normalize(opt.title || '').includes(term));
                return filtered;
              }}
              noOptionsText="No categories found"
              clearOnBlur={false}
              openOnFocus={true}
              disableCloseOnSelect={true}
              value={selectedOptionObjects}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              onChange={(event, _newValue) => {
                const values = _newValue || [];
                const ids = values.map(option => option?.id).filter(Boolean);
                selectCouponCategories([...new Set(ids)]);
              }}
              renderOption={(props, option, { selected }) => {
                // props is spread onto the li element; don't remove it.
                return (
                  <li {...props} key={option?.id}>
                    {option?.title}
                  </li>
                );
              }}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip key={option?.id ?? index} variant="outlined" label={option?.title} {...getTagProps({ index })} style={{
                    backgroundColor: '#2b1de8',
                    color: 'white',
                    fontWeight: 'bold',
                    border: 'none',
                  }}
                  deleteIcon={<Cancel style={{ color: 'white', fontSize: '18px' }} />} />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="filled"
                  placeholder={couponDetails?.categories?.length > 0 ? '' : "Select Categories"}
                  InputProps={{ ...params.InputProps, style: { backgroundColor: 'white' } }}
                />
              )}
            />
              {errors?.categories?.show && <div className="coupon-error-text">{errors.categories.message}</div>}
            </Card>
            <Card className='card-container' sx={{ width: '100%', maxHeight: "500px", overflowY: 'auto', padding: "0rem !important", gap: "0rem !important" }}>
              {categoriesData.map((item, index1) => <Accordion 
                  key={item.parent.id} sx={{ width: "100%" }} expanded={expandId === `${item.parent.title}-index${index1}`} onChange={handlePanelChange(`${item.parent.title}-index${index1}`)} >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel3-content"
                  id="panel3-header"
                  sx={{ gap: '0rem' }}
                  onClick={() => {
                    setAccordionDetails(item.children);
                  }}
                >
                  {item.parent.title}
                </AccordionSummary>
                <AccordionDetails>
                  {accorrdionDetails && accorrdionDetails.length > 0 && accorrdionDetails.map((option, index2) =>
                    <div key={option.title + index1 + index2}
                      className='flex-row-container'
                    >
                      <span>{option.title}</span>
                      <Button onClick={() => {
                        selectCouponCategories([...new Set([...couponDetails.categories, option.id])])
                      }} sx={{ color: "#2b1de8" }}>+ Add</Button>
                    </div>
                  )}
                </AccordionDetails>
              </Accordion>)}
            </Card></>}
        </div>
        <div className='horizontal-row-card-container vertical'>

          <Card className='card-container' sx={{ width: '100%' }}>
            <span className='title'>Details to claim coupon</span>
            <div className='mutiple-text-field-container'>
              <div className='textfields-container'>
                <TextField
                  id="standard-multiline-static"
                  label="Coupon Website (URL where coupon can be claimed)"
                  value={couponDetails.couponClaimUrl}
                  onChange={(e) => setCouponClaimUrl(e.target.value)}
                  fullWidth
                  placeholder='Coupon Website URL it applicable(include full address with http:// or https://)'
                  variant="standard"
                  onFocus={() => setError("website", false)}
                />
                {errors?.website?.show && <div className="coupon-error-text">{errors.website.message}</div>}
                <TextField
                  id="standard-multiline-static"
                  value={couponDetails.phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  fullWidth
                  onFocus={() => setError('phone', false)}
                  placeholder='Phone / Mobile Number'
                  variant="standard"
                />
                {errors?.phone?.show && <div className="coupon-error-text">{errors.phone.message}</div>}
                <TextField
                  id="standard-multiline-static"
                  value={couponDetails.emailAddress}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  onFocus={() => setError('mail', false)}
                  placeholder='Email Address'
                  variant="standard"
                />
                {errors?.mail?.show && <div className="coupon-error-text">{errors.mail.message}</div>}
                {errors?.contactMethod?.show && <div className="coupon-error-text">{errors.contactMethod.message}</div>}

              </div>
              <img src='https://admin.delivait.com/assets/img/add-terms.png' />

            </div>

            <div className='single-text-field-container'>
              <form onSubmit={handleKeyboardSubmit}>
                <TextField
                  id="standard-multiline-static"
                  label="Keywords"
                  fullWidth
                  placeholder='press enter to add a keyword'
                  value={currentKeyword}
                  onChange={(e) =>
                    setKeyword(e.target.value)
                  }
                  variant="standard"
                  onFocus={() => setError('keywords', false)}
                />

              </form>

              <span className='subtitle checkbox-container'><Checkbox checked={companyIncluded} onChange={(e) => {
                const checked = e.target.checked;
                setCompanyIncluded(checked);
                // Store checkbox state in couponDetails so it's available when submitting
                setCouponDetails({ ...couponDetails, companyKeywords: checked });
              }} sx={{
              '& .MuiSvgIcon-root': { fontSize: 30 }
            }} />
                Add this to the company keywords too
              </span>
            </div>

            <div className='keyword-list'>

              {couponDetails?.keywords?.map((keyword, index) => <div key={keyword + index} className='keywordBatch'>
                <span>{keyword}</span>
                <Close onClick={() => {
                  selectKeywords(couponDetails.keywords.filter((item) => item != keyword))
                }} />
              </div>)}
            </div>

            {errors?.keywords?.show && <div className="coupon-error-text">{errors.keywords.message}</div>}


          </Card>

          <Card className='card-container' sx={{ width: '100%' }}>
            <span className='title'>Coupon Code</span>

            <div className='single-text-field-container'>
              <TextField
                id="standard-multiline-static"
                label="Enter a code for your coupon.."
                value={couponDetails.couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                // defaultValue={""}
                fullWidth
                onFocus={() => setError('code', false)}
                placeholder='i.e 4AEGAE86'
                variant="standard"
              />

              <img src='https://admin.delivait.com/assets/img/add-terms.png' />
            </div>

            {errors?.code?.show && <div className="coupon-error-text">{errors.code.message}</div>}
          </Card>
        </div>
      </div>


    </div>
  )
}
